<div class="dialog-container">
  <h2 mat-dialog-title>Add Bulk Station Rates</h2>

  <div class="station-info">
    <mat-icon>radio</mat-icon>
    <span>{{ data.station.call_sign }} - {{ data.station.name }}</span>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="manual-section">
      <div class="new-rate-form">
        <div class="rate-inputs">
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Spot Length</mat-label>
            <mat-select [(ngModel)]="newRate.spot_length" name="spot_length">
              @for (option of spotLengthOptions; track option.value) {
                <mat-option [value]="option.value">{{ option.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Start Hour</mat-label>
            <mat-select [(ngModel)]="newRate.start_hour" name="start_hour">
              @for (hour of hourOptions; track hour.value) {
                <mat-option [value]="hour.value">{{ hour.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Last Hour (inclusive)</mat-label>
            <mat-select [(ngModel)]="newRate.end_hour" name="end_hour">
              @for (hour of endHourOptions; track hour.value) {
                <mat-option [value]="hour.value" [disabled]="hour.value < newRate.start_hour">{{ hour.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="money-field">
            <mat-label>CPM</mat-label>
            <span matTextPrefix class="currency-prefix">$</span>
            <input matInput type="number" [(ngModel)]="newRate.cpm" name="cpm" min="0" step="0.01">
          </mat-form-field>
        </div>

        <div class="days-section">
          <span class="days-label">Days</span>
          <div class="day-chips">
            <button type="button" class="day-chip" [class.active]="newRate.days.mon" (click)="newRate.days.mon = !newRate.days.mon">Mon</button>
            <button type="button" class="day-chip" [class.active]="newRate.days.tue" (click)="newRate.days.tue = !newRate.days.tue">Tue</button>
            <button type="button" class="day-chip" [class.active]="newRate.days.wed" (click)="newRate.days.wed = !newRate.days.wed">Wed</button>
            <button type="button" class="day-chip" [class.active]="newRate.days.thu" (click)="newRate.days.thu = !newRate.days.thu">Thu</button>
            <button type="button" class="day-chip" [class.active]="newRate.days.fri" (click)="newRate.days.fri = !newRate.days.fri">Fri</button>
            <button type="button" class="day-chip" [class.active]="newRate.days.sat" (click)="newRate.days.sat = !newRate.days.sat">Sat</button>
            <button type="button" class="day-chip" [class.active]="newRate.days.sun" (click)="newRate.days.sun = !newRate.days.sun">Sun</button>
          </div>
        </div>

        <div class="add-rate-actions">
          <button mat-raised-button color="primary" type="button" (click)="addManualRate()">
            <mat-icon>add</mat-icon>
            Add Rate
          </button>
        </div>
      </div>

      @if (manualRates.length > 0) {
        <div class="added-rates">
          <h4>Queued ({{ manualRates.length }})</h4>
          <div class="rates-list">
            @for (rate of manualRates; track $index) {
              <div class="rate-item">
                <div class="rate-details">
                  <span class="rate-time">{{ formatHour(rate.start_hour) }}-{{ formatHour((rate.end_hour + 1) % 24) }}</span>
                  <span class="rate-days">{{ formatDays(rate.days) }}</span>
                  <span class="rate-spot">{{ rate.spot_length }}s</span>
                  <span class="rate-price">${{ rate.cpm }}</span>
                </div>
                <button mat-icon-button type="button" class="remove-rate-btn" (click)="removeManualRate($index)" title="Remove rate">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-stroked-button type="button" (click)="onCancel()" [disabled]="loading">Cancel</button>
    <button mat-raised-button color="primary" type="button" class="dialog-primary-submit" (click)="onSubmit()" [disabled]="loading || !isFormValid()">
      @if (loading) {
        <span class="dialog-primary-submit__inner">
          <mat-spinner diameter="20" class="dialog-primary-submit__spinner" />
          <span>Creating…</span>
        </span>
      } @else {
        <span>Create {{ manualRates.length }} Rates</span>
      }
    </button>
  </mat-dialog-actions>
</div>
